import { IonApp, setupIonicReact } from '@ionic/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { AppProviders } from '@app/providers/app-providers'
import { AppRouter } from '@app/router/app-router'
import './GlobalStyles.css'

setupIonicReact({})

const container = document.getElementById('root')

if (!container) {
	throw new Error('Root element is missing')
}

createRoot(container).render(
	<StrictMode>
		<IonApp>
			<AppProviders>
				<AppRouter />
			</AppProviders>
		</IonApp>
	</StrictMode>,
)
